import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/fr'; // Import de la locale française
import Table, { TableColumn } from '../Table';
import "./ListComponent.scss";
moment.locale('fr'); // Définir la locale en français pour les dates
function ListeComponent({ table }: any) {
  const [paiement, setPaiement] = useState<[]>([]);
  const [dateDebut, setDateDebut] = useState<string>('');
  const [dateFin, setDateFin] = useState<string>('');
  const [tempDateDebut, setTempDateDebut] = useState<string>('');
  const [tempDateFin, setTempDateFin] = useState<string>('');
  const [searchTrigger, setSearchTrigger] = useState<number>(0);
  
  const columns: TableColumn[] = [
    {
      field: "ordre",
      headerName: "N°Ordre",
      maxWidth: 80
    },
    {
      field: 'chassis',
      headerName: "N°Chassis",
      minWidth: 120,
    },
    {
      field: "paiementNumber",
      headerName: "N°Paiement",
      minWidth: 180
    },
    {
      field: "fullname",
      headerName: "Fait par",
      minWidth: 180
    },
    {
      field: "created_at",
      headerName: "Date",
      minWidth: 180
    },
    {
      field: "options",
      headerName: "Options",
      sortable: false,
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <div className="options">
            <Link to={`/recepissedetails/${params.row.paiementNumber}`}>
              <button>Voir</button>
            </Link>
          </div>
        );
      },
    }
  ];

  const handleSearch = () => {
    setDateDebut(tempDateDebut);
    setDateFin(tempDateFin);
    setSearchTrigger(prev => prev + 1);
  };

  const handleClearFilters = () => {
    setTempDateDebut('');
    setTempDateFin('');
    setDateDebut('');
    setDateFin('');
    setSearchTrigger(prev => prev + 1);
  };

  React.useEffect(() => {
    let filteredData = table?.map((item: any, index: number) => {
      return {
        ordre: index + 1,
        id: item?.id,
        chassis: item?.chassis,
        paiementNumber: item?.paiementNumber,
        fullname: item?.user[0].prenom + " " + item?.user[0].nom,
        created_at: moment(item?.created_at).format("DD MMMM YYYY"),
        created_at_raw: moment(item?.created_at) // Garder la date brute pour le filtrage
      }
    });

    // Appliquer le filtrage par date si les dates sont définies
    if (dateDebut || dateFin) {
      filteredData = filteredData?.filter((item: any) => {
        const itemDate = item.created_at_raw;
        let isValid = true;

        if (dateDebut) {
          const startDate = moment(dateDebut);
          isValid = isValid && itemDate.isSameOrAfter(startDate, 'day');
        }

        if (dateFin) {
          const endDate = moment(dateFin);
          isValid = isValid && itemDate.isSameOrBefore(endDate, 'day');
        }

        return isValid;
      });
    }

    setPaiement(filteredData || []);
  }, [table, dateDebut, dateFin, searchTrigger]);

  return (
    <div className='liste'>
      {/* Section des filtres */}
      <div className='liste__filters'>
        <div className='liste__filters__date-range'>
          <div className='liste__filters__date-range__item'>
            <label htmlFor='dateDebut'>Date de début :</label>
            <input
              type='date'
              id='dateDebut'
              value={tempDateDebut}
              onChange={(e) => setTempDateDebut(e.target.value)}
            />
          </div>
          <div className='liste__filters__date-range__item'>
            <label htmlFor='dateFin'>Date de fin :</label>
            <input
              type='date'
              id='dateFin'
              value={tempDateFin}
              onChange={(e) => setTempDateFin(e.target.value)}
            />
          </div>
          <div className='liste__filters__actions'>
            <button
              className='liste__filters__search'
              onClick={handleSearch}
            >
              Rechercher
            </button>
            <button
              className='liste__filters__clear'
              onClick={handleClearFilters}
            >
              Effacer
            </button>
          </div>
        </div>
      </div>

      <div className='liste__table'>
        <Table
          rows={paiement}
          columns={columns}
          pageSize={10}
          showSearch={true}
          showPagination={true}
        />
      </div>
    </div>
  )
}

export default ListeComponent